import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export type SettingsTab =
  | "general"
  | "notifications"
  | "depot"
  | "job_types"
  | "pickup_location_types"
  | "bunkerType"
  | "customer_types"
  | "truck_types"
  | "access_groups"
  | "teams";

const TAB_PARAM = "tab";
const DEFAULT_TAB: SettingsTab = "general";
const TABS: SettingsTab[] = [
  "general",
  "notifications",
  "depot",
  "job_types",
  "pickup_location_types",
  "bunkerType",
  "customer_types",
  "truck_types",
  "access_groups",
  "teams",
];
const isValidTab = (tab: string | null): tab is SettingsTab => {
  return TABS.includes(tab as SettingsTab);
};

export const useSettingsTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get(TAB_PARAM);
  const activeTab = isValidTab(tabParam) ? tabParam : DEFAULT_TAB;

  const setActiveTab = useCallback(
    (tab: SettingsTab) => {
      setSearchParams((params) => {
        if (tab === DEFAULT_TAB) {
          params.delete(TAB_PARAM);
        } else {
          params.set(TAB_PARAM, tab);
        }
        return params;
      });
    },
    [setSearchParams],
  );

  return {
    activeTab,
    setActiveTab,
    tabs: TABS,
  };
};
